import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorAdminDashboardReadSlice = createSlice({
  name: "TutorAdminDashboardReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorAdminDashboardRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successTutorAdminDashboardRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorAdminDashboardRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorAdminDashboardRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorAdminDashboardRead,
  successTutorAdminDashboardRead,
  failureTutorAdminDashboardRead,
  clearTutorAdminDashboardRead,
} = TutorAdminDashboardReadSlice.actions;

export default TutorAdminDashboardReadSlice.reducer;
